module.exports = __webpack_public_path__ + "img/ico-facebook.20caac44.svg";